function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.5,1.7c-0.4,0-0.7,0.3-0.7,0.7l-0.1,3.2l0,0C16.9,3.9,14.6,3,12.1,3C9.5,3,7.2,4,5.4,5.8C3.6,7.6,2.6,10,2.6,12.5 c0,2.5,1,4.9,2.8,6.7c1.8,1.8,4.3,2.8,6.8,2.8c2,0,4-0.6,5.7-1.9c0.3-0.2,0.4-0.7,0.1-1c-0.2-0.3-0.7-0.4-1-0.1 c-3.2,2.4-7.8,2.1-10.7-0.7C4.8,16.7,4,14.7,4,12.5c0-2.2,0.8-4.2,2.4-5.7c1.5-1.5,3.6-2.4,5.7-2.4c2.1,0,4.1,0.8,5.6,2.2l0,0 l-3.2,0.1c-0.4,0-0.8,0.4-0.8,0.8c0.1,0.4,0.4,0.7,0.8,0.7h4c1,0,1.8-0.8,1.8-1.8v-4C20.3,2,19.9,1.7,19.5,1.7z"
});

var SvgReset = function SvgReset(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "currentColor",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReset, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reset.7e8dd8a4.svg";
export { ForwardRef as ReactComponent };